import React from 'react';
import CTABanner from '../components/landingPage/CTABanner';
import SocialMediaCTA from '../components/SocialMediaCTA';
import NewsSection from '../components/landingPage/NewsSection';

const expertiseData = [
  {
    name: 'Awning ACP or Steel',
    image: '/Our_expertise_img/Awning ACPor Steel.PNG',
    description: 'Expert fabrication and installation of durable awnings using ACP (Aluminum Composite Panel) and steel structures, perfect for commercial and residential applications.'
  },
  {
    name: 'Commercial I beam structure and roofing',
    image: '/Our_expertise_img/Commercial I beam  structure and roofing.PNG',
    description: 'Supply and erection of high-strength I-beams for commercial construction, ensuring robust structural integrity for large-scale projects, including comprehensive roofing solutions.'
  },
  {
    name: 'Fencing',
    image: '/Our_expertise_img/Fencing.PNG',
    description: 'Custom metal fencing solutions for security, privacy, and aesthetic enhancement of residential, commercial, and industrial properties.'
  },
  {
    name: 'Metal Hoarding',
    image: '/Our_expertise_img/Metal Hoarding.PNG',
    description: 'Robust metal hoarding solutions for construction sites, providing security, safety, and privacy while maintaining a professional appearance.'
  },
  {
    name: 'Metal roofing',
    image: '/Our_expertise_img/Metal roofing.PNG',
    description: 'Specialized in metal roofing solutions, offering superior durability, weather resistance, and modern aesthetics for various building types.'
  },
  {
    name: 'MS or SS Grating',
    image: '/Our_expertise_img/MSor SS Grating.PNG',
    description: 'Fabrication and installation of Mild Steel (MS) or Stainless Steel (SS) gratings for drainage, platforms, and walkways, ensuring durability and safety.'
  },
  {
    name: 'MS or SS Hand Railing',
    image: '/Our_expertise_img/MS or SS Hand Railing.PNG',
    description: 'Custom-designed Mild Steel (MS) or Stainless Steel (SS) hand railings, combining safety, functionality, and sleek design for various architectural needs.'
  },
  {
    name: 'Security Gate',
    image: '/Our_expertise_img/Security Gate.PNG',
    description: 'Custom-designed and fabricated security gates for industrial, commercial, and residential properties, ensuring robust protection and controlled access.'
  },
  {
    name: 'Signboard Frame',
    image: '/Our_expertise_img/Singboard Frame.PNG',
    description: 'Durable and custom-built signboard frames for effective outdoor advertising and branding, designed to withstand various weather conditions.'
  },
  {
    name: 'Steel Deck or Staircase',
    image: '/Our_expertise_img/Steel Deck or Staircase.PNG',
    description: 'Fabrication and installation of robust steel decks and staircases, offering modern design, durability, and structural integrity for various applications.'
  },
  {
    name: 'Warehouse or Site Office',
    image: '/Our_expertise_img/Warehouse or Site Office.PNG',
    description: 'Modular and custom-built warehouse site offices, offering efficient and comfortable on-site facilities for project management and operations.'
  },
  {
    name: 'Signage Wall',
    image: '/Our_expertise_img/Sigage Wall.PNG',
    description: 'Construction of robust and visually appealing signage walls, providing a strong foundation for corporate branding and outdoor advertising.'
  }
];

const OurExpertisePage = () => {
  return (
    <div className="min-h-screen pt-40 bg-gray-100 font-poppins py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-main-blue text-center mb-8 sm:mb-12">
          Our Expertise
        </h1>

        <section className="mb-12 sm:mb-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 sm:gap-8">
            {expertiseData.map((expertise, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden group hover:shadow-xl transition-shadow duration-300">
                <img
                  src={expertise.image}
                  alt={expertise.name}
                  className="w-full h-40 sm:h-48 object-cover"
                />
                <div className="p-4 sm:p-6">
                  <h3 className="mt-5 sm:mt-6 text-lg sm:text-xl font-bold text-main-blue">{expertise.name}</h3>
                  <p className="text-gray-700 mt-3 sm:mt-4 text-sm sm:text-base">{expertise.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
         <CTABanner className="my-8 sm:my-12 " />
        <SocialMediaCTA className="my-8 sm:my-12" />
        <NewsSection className="my-8 sm:my-12" />
      </div>
    </div>
  );
};

export default OurExpertisePage;
